var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showTimeSinceSave)?_c('div',{staticClass:"o-save-timer",on:{"click":_vm.save}},[(_vm.saveDisabled)?_c('b',[_vm._v("There is nothing left to save.")]):_c('span',[_vm._v("Time since last save: "+_vm._s(_vm.timeString))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }